"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNavItemsContextProvider = exports.useNavItemsProviderProps = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_fast_compare_1 = tslib_1.__importDefault(require("react-fast-compare"));
const Provider_1 = require("../app/Provider");
function useNavItemsProviderProps(props) {
    var _a;
    const [navItems, internalSetNavItems] = react_1.useState(((_a = props === null || props === void 0 ? void 0 : props.navItems) !== null && _a !== void 0 ? _a : []));
    const setNavItems = (navItems) => {
        react_1.useEffect(() => {
            internalSetNavItems((originNavItems) => {
                if (react_fast_compare_1.default(originNavItems, navItems)) {
                    return originNavItems;
                }
                return navItems;
            });
        }, [navItems, internalSetNavItems]);
    };
    return Object.assign({ navItems, setNavItems }, props);
}
exports.useNavItemsProviderProps = useNavItemsProviderProps;
function createNavItemsContextProvider(props) {
    const { Context: NavItemsContext, useContext: useNavItemsContext } = Provider_1.createProvider(Object.assign({ navItems: [], setNavItems: (navItems) => {
            navItems;
        } }, props));
    const NavItemsContextProvider = (_a) => {
        var props = tslib_1.__rest(_a, []);
        const value = useNavItemsProviderProps(props);
        return jsx_runtime_1.jsx(NavItemsContext.Provider, Object.assign({ value: value }, { children: props.children }), void 0);
    };
    return { NavItemsContext, useNavItemsContext, NavItemsContextProvider };
}
exports.createNavItemsContextProvider = createNavItemsContextProvider;
//# sourceMappingURL=NavItemsContextProvider.js.map